//https://www.jsmount.com/how-to-create-a-common-helper-class-or-util-file-in-react-js/
class T {
	// static test(){
	//     return ["SS","EE","FF","GGG"];
	// }
	//0 to n-1
	static roundToTwo(num) {
		return +(Math.round(num + "e+2") + "e-2");
		//parseFloat(props.value/props.weight).toFixed(2);
	}
	static roundToFix(num, n) {
		return parseFloat(num).toFixed(n);
	}
	static str_toListInt(a, splitter) {
		//https://stackoverflow.com/questions/15677869/how-to-convert-a-string-of-numbers-to-an-array-of-numbers
		var s = ",";
		if (splitter != null) {
			s = splitter;
		}
		// console.log("sss " + s);
		return Array.from(a.split(s), Number);
	}
	static str_LinestoListInt(a, allowNaN) {
		if (allowNaN == null) {
			allowNaN = true;
		}
		var list = [];
		const arr = a.split("\n");
		for (const b of arr) {
			if (b != "") {
				let x = parseInt(b);
				if (allowNaN || !isNaN(x)) {
					list.push(x);
				}
			}
		}
		return list;
	}
	static isNaN(x) {
		return x !== x;
	}
	static arr_clone(arr) {
		return [...arr];
	}
	// static arr_cloneSelect(arr, start, end) {
	// 	//start TO end - 1
	// 	return [...arr.slice(start, end)];
	// }
	static arr_cloneAdd(arr, a) {
		var arrnew = [...arr];
		arrnew.push(a);
		return arrnew;
	}
	static arr_cloneAddFront(arr, a) {
		var arrnew = [a];
		arrnew.push(...arr);
		return arrnew;
	}
	static arr_getMean(arr) {
		var sum = 0;
		for (var number of arr) {
			sum += number;
		}
		var average = sum / arr.length;
		return average;
	}
	static arr_getSUM(arr) {
		// var sum = 0;
		// for (var number of arr) { sum += number; }
		// return sum;
		return arr.reduce(function (a, b) {
			return a + b;
		}, 0);
	}
	//remove item from subset on superset, item appear in order
	static arr_subtract_subset_inOrder(set, subset) {
		var j = 0;
		var output = [];
		for (var i = 0; i < set.length; i++) {
			if (set[i] != subset[j]) {
				output.push(set[i]);
			} else {
				j++;
			}
		}
		return output;
	}
	static listSort(list) {
		//https://stackoverflow.com/questions/43572436/sort-an-array-of-objects-in-react-and-render-them
		return list.sort((a, b) => a - b);
	}
	static listSort_desc(list) {
		return list.sort((a, b) => b - a);
	}
	static listInt_printX(list) {
		//2,1,1 >> 2,1x2
		return list.sort((a, b) => b - a);
	}
	static arr_max(array) {
		return Math.max.apply(Math, array);
	}
	static getMatrix(r, c) {
		//https://stackoverflow.com/questions/8301400/how-do-you-easily-create-empty-matrices-javascript
		return new Array(r).map(() => new Array(c));
	}
	static getMatrix(r, c, v) {
		//https://stackoverflow.com/questions/8301400/how-do-you-easily-create-empty-matrices-javascript
		return new Array(r).fill(v).map(() => new Array(c).fill(v));
	}
	static getMatrix_empty(r, c) {
		//https://stackoverflow.com/questions/8301400/how-do-you-easily-create-empty-matrices-javascript
		return new Array(r).map(() => new Array(c));
	}
	static listPrint(r, c, v) {
		//https://stackoverflow.com/questions/8301400/how-do-you-easily-create-empty-matrices-javascript
		return new Array(r).fill(v).map(() => new Array(c).fill(v));
	}
	static strPrint_splitSpaceEveryN(list, splitter, n) {
		//1,1,1,1,1,1,1,1,1,1,1,1 >> 1,1,1, 1,1,1, 1,1,1, 1,1,1
		var output = "";
		var arr = list.split(splitter);
		for (var i = 0; i < arr.length; i++) {
			if (output != "") {
				output += splitter;
				if (i % n == 0) {
					output += " ";
				}
			}
			output += arr[i];
		}
		return output;
	}
	static listAdd(list, x) {
		var list_new = list.slice();
		list_new.push(x);
		return list_new;
	}
	static getValue(x, d) {
		//get from gui or whatever, if not null > if null, use default d
		var a = x;
		if (a == null) {
			a = d;
		}
		return a;
	}
	static strReverse(str) {
		return str.split("").reverse().join("");
	}
	static arr_getDiff(arr1, arr2) {
		//2-1
		var arr_output = [arr1.length];
		for (var i = 0; i < arr1.length; i++) {
			arr_output.push(arr2[i] - arr1[i]);
		}
		return arr_output;
	}
	//====================================
	static obj_print(obj) {
		//e.g., { id:1 v:2}
		return JSON.stringify(obj, null, 4);
	}
	static log_obj(obj1) {
		console.log(JSON.stringify(obj1, null, 4));
	}
	static log_obj2(pretxt, obj1, posttxt) {
		console.log(pretxt + JSON.stringify(obj1, null, 4) + posttxt);
	}
	static arr_countTrue(arr) {
		return arr.filter(Boolean).length;
	}
	static deci_toPercent(num) {
		//console.log(formatAsPercent(25.49));  >> 25%
		return new Intl.NumberFormat("default", {
			style: "percent",
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(num / 100);
	}
	static str_noBlankLine(str) {
		return str
			.split(/\r?\n/) // Split input text into an array of lines
			.filter((line) => line.trim() !== "") // Filter out lines that are empty or contain only whitespace
			.join("\n"); // Join line array into a string
	}
	static str_toListArray(str, seperator) {
		var listArr = [];
		var lines = str.split("\n");
		for (const l of lines) {
			listArr.push(l.split(seperator));
		}
		return listArr;
	}
	//list of []
	static str_toListArray_noEmpty(str, seperator) {
		var str2 = T.str_noBlankLine(str);
		return T.str_toListArray(str2, seperator);
	}

	static arrs_getCommon(arr1, arr2) {
		var output = [];
		var i = 0;
		var j = 0;
		while (i < arr1.length && j < arr2.length) {
			if (arr1[i] == arr2[j]) {
				output.push(arr1[i]);
				i++;
				j++;
			} else if (arr1[i] < arr2[j]) {
				i++;
			} else {
				j++;
			}
		}
		return output;
	}
	static matrix_print(matrix) {
		var output = "";
		for (var i = 0; i < matrix.length; i++) {
			// for (var z = 0; z < matrix[i].length; z++) {
			// 	output += matrix[z][i];
			// }
			if (i > 0) {
				output += "\n";
			}
			output += matrix[i];
		}
		return output;
	}
	static arr_calSumFromHere(arr) {
		//summation from i to end of array
		var sum = 0;
		var sum_fromhere = [arr.length - 1];
		for (var i = arr.length - 1; i >= 0; i--) {
			sum += arr[i];
			sum_fromhere[i] = sum;
		}
		return sum_fromhere;
	}
	static arr_addRange(arr1, arr2) {
		arr1.push(...arr2);
	}
	static arr_addRange_select(arr1, arr2, start, end) {
		arr1.push(...arr2.slice(start, end)); //select from to start to BEFORE end
	}
	static arr_concat_select(arr1, arr2, start, end) {
		var output = [];
		output.push(...arr1);
		output.push(...arr2.slice(start, end)); //select from to start to BEFORE end
		return output;
	}
	static str_newline(str) {
		return str == "" ? "" : "\n";
	}
	static arr_getFrequency(arr) {
		//https://stackoverflow.com/questions/5667888/counting-the-occurrences-frequency-of-array-elements
		return arr.reduce(function (acc, curr) {
			return acc[curr] ? ++acc[curr] : (acc[curr] = 1), acc;
		}, {});
	}
	
	//get string like "aabbddd", return int[]
	static arr_getFrequency_str(string) {
		var freq = {};
		for (var i=0; i<string.length;i++) {
			var character = string.charAt(i);
			if (freq[character]) {
			   freq[character]++;
			} else {
			   freq[character] = 1;
			}
		}
		return freq;
	}

	static arr_getFrequency_str_remove(str,removechar) {
		return T.arr_getFrequency_str(str.replaceAll(removechar, ''));
	}

	static arr_getFrequency_print(arr, intra_connect, inter_connect, skipFreq1) {
		var freq = T.arr_getFrequency(arr);
		var txt = "";
		for (const [key, value] of Object.entries(freq)) {
			if (txt != "") {
				txt += inter_connect;
			}
			txt += key;
			if (!skipFreq1 || value > 1) {
				txt += intra_connect + value;
			}
		}
		return txt;
	}
	static arr_getLast(arr, default1) {
		return arr.length > 0 ? arr[arr.length - 1] : default1;
	}
	static arr_splitToSubarray(arr) {
		//[1,2,3] >> [[1],[2],[3]]
		var output = [];
		for (var i = 0; i < arr.length; i++) {
			var a = [arr[i]]; //array with 1 element
			output.push(a);
		}
		return output;
	}
	static subarray(arr, s, e) {
		return arr.slice(s, e + 1);
	}
	static arr_subsetCheck(arr, subarr) {
		if (arr == null || subarr == null) {
			return false;
		}
		// console.log("ARRAYS " + arr + "_" + subarr);
		// console.log("LENGTH " + arr.length + "_" + subarr.length);
		// return arr.includes(subarr);
		let b = subarr.every((e) => arr.includes(e));
		// console.log("ANS " + b);
		return b;
	}
	static substring(str, a, b) {
		return str.toString().substring(a, b);
	}
	static substring_from(str, a) {
		return str.toString().substring(a);
	}
	static loop_newLine(txt) {
		return txt != "" ? "\n" : "";
	}
	static arr_isSorted(arr) {
		let second_index;
		for (let first_index = 0; first_index < arr.length; first_index++) {
			second_index = first_index + 1;
			if (arr[second_index] - arr[first_index] < 0) return false;
		}
		return true;
	}
	static rand(max) {
		return Math.floor(Math.random() * max);
	  }

	  static str_nospace(str){
		return str.replace(/\s/g, '');
	  }
	
}
export default T;
